import React from 'react';
import ScrollToTop from './components/ScrollToTop';
import {BrowserRouter} from 'react-router-dom';
import {Route, Routes} from 'react-router';
import {UserStorage} from './UserContext';
import GlobalStyle from './styles/global';
import LoginRoutes from './routes/LoginRoutes';
import CookiesBar from './components/CookiesBar';
import HeaderAlternative from './components/HeaderAlternative';
import JustNotLoginRoutes from './routes/JustNotLoginRoutes';
import Footer from './components/Footer';

function App() {    
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop/>
                <HeaderAlternative/>
                <UserStorage>
                    <Routes basename={'area-restrita'}>
                        <Route path="/*" element={<JustNotLoginRoutes/>}/>
                        <Route path="/usuario/*" element={<LoginRoutes/>}/>
                    </Routes>
                </UserStorage>
                <CookiesBar/>
                <Footer/>
            </BrowserRouter>
            <GlobalStyle/>
        </div>
    );
}

export default App;
